import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IncludedInModule } from '@portal-core/general/pipes/included-in/included-in.module';
import { PluralizeModule } from '@portal-core/general/pipes/pluralize/pluralize.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUserForLicenseAsyncModule } from '@portal-core/license-users/pipes/license-user-for-license-async/license-user-for-license-async.module';
import { WorkspaceFileUserStatusAvatarIndicatorModule } from '@portal-core/workspaces/components/workspace-files-user-status-avatar-indicator/workspace-file-user-status-avatar-indicator.module';
import { WorkspaceFileUserStatusListComponent } from './workspace-file-user-status-list.component';

@NgModule({
  declarations: [WorkspaceFileUserStatusListComponent],
  imports: [
    CommonModule,
    IncludedInModule,
    LicenseUserAvatarModule,
    LicenseUserForLicenseAsyncModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    PluralizeModule,
    WorkspaceFileUserStatusAvatarIndicatorModule
  ],
  exports: [
    WorkspaceFileUserStatusListComponent
  ]
})
export class WorkspaceFileUserStatusListModule { }
